import { Skeleton } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { TeamCard } from "../team/TeamCard";
import { AppPage } from "../utils/AppPage";
import { NoItemCard } from "../utils/NoItemCard";
import { LeaderboardPanel } from "./LeaderboardPanel";

export const LeaderboardPage = () => {
  const api = useAPI();
  const { data, state, query } = useAPIQuery({ apiCall: api.teamGet });

  const teams = useMemo(() => data?.teams ?? [], [data?.teams]);

  useEffect(() => {
    query({ orderBy: "points", ordering: "DESC" });
  }, [query]);

  return (
    <AppPage title="Leaderboard">
      <LeaderboardPanel teams={teams} />
      {state === "success" && data ? (
        data.teams.length > 0 ? (
          data.teams.map((team) => <TeamCard team={team} key={team.id} />)
        ) : (
          <NoItemCard
            description="No teams exist"
            buttonText="Create Team"
            navigateUrl="/team/new"
          />
        )
      ) : (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      )}
    </AppPage>
  );
};
